import { useMemo, useRef } from "react";
import { uniq } from "underscore";

import useTenantUsers from "../api/api-hooks/tenantUsers/useTenantUsers";
import { PageMember } from "../types/GlobalInterfaces";
import useUser from "../api/api-hooks/auth/useUser";

const usePagePeople = (members: PageMember[]) => {
  const { users } = useTenantUsers();
  const { pPermissions: pagePermissions } = useUser();
  const membersRef = useRef<PageMember[]>();
  const membersStringified = useMemo(() => JSON.stringify(members), [members]);
  membersRef.current = members;

  const pagePeople = useMemo(() => {
    const members = membersRef.current;

    if (!members || !members.length) return [];

    let memberMap = members.flatMap((member) => {
      const foundUser = (users ?? [])?.find(
        (u: any) => u.id === member.PersonID
      );

      if (!foundUser) {
        return [];
      }

      const permissionID = member.Permissions?.PageProfile;
      const permissions = (pagePermissions ?? [])?.find(
        (p) => p.id === permissionID
      );

      foundUser.PagePermissions = permissions;
      foundUser.Owner = !!member.Owner;

      return [foundUser];
    });

    memberMap = uniq(memberMap, true, (u) => {
      return u.id;
    });

    return memberMap;
  }, [membersStringified, users, pagePermissions]);

  return pagePeople;
};

export default usePagePeople;
